import {
  MODEL_AVAILABILITY,
  MODEL_CHANGE,
  MODEL_RANK_CHANGE,
  NEW_EVALUATION,
  NEW_MODEL,
  TOP_MODEL,
  FREE_RESPONSE_QUESTION,
  MULTIPLE_CHOICE_QUESTION,
  BOOLEAN_QUESTION,
  JSON_QUESTION,
  EMAIL,
  WEBHOOK,
  SCORE_THRESHOLD,
} from 'services/constants'

export const modalities = {
  text: 'Text',
}
export const taskTypes = {
  [FREE_RESPONSE_QUESTION]: 'Free response',
  [MULTIPLE_CHOICE_QUESTION]: 'Multiple choice',
  [BOOLEAN_QUESTION]: 'Boolean',
  [JSON_QUESTION]: 'JSON',
}
export const schemaTypes = {
  [JSON_QUESTION]: 'JSON',
}
export const alertCadences = {
  once: 'Only once',
  daily: 'Once per day',
  always: 'Every time',
}
export const architectures = {
  llm: 'LLM',
  nn: 'Neural network',
  Transformer: 'Transformer',
}
export const allTags = {
  truthful: 'truthful',
  helpful: 'helpful',
  harmful: 'harmful',
  alignment: 'alignment',
  deceitful: 'deceitful',
}

export const viewOptions = {
  correct: 'Correct answers',
  incorrect: 'Incorrect answers',
  redacted: 'Redacted',
}

export const runCadences = ['once', 'daily', 'weekly', 'every 2 weeks', 'monthly', 'quarterly']

export const alertTriggerTypes = {
  [TOP_MODEL]: 'New Top Model',
  [MODEL_RANK_CHANGE]: 'Model Rank Change',
  [MODEL_AVAILABILITY]: 'Model Availability',
  [NEW_MODEL]: 'New Model Release',
  [NEW_EVALUATION]: 'New Evaluation Added',
  [MODEL_CHANGE]: 'Existing Model Change',
  [SCORE_THRESHOLD]: 'Model Score Threshold',
}

export const notificationTypes = {
  [EMAIL]: 'Email',
  [WEBHOOK]: 'Webhook',
  // [TEXT_MESSAGE]: 'SMS message',
  // [PHONE_CALL]: 'Phone call',
}
